// Builds AdvancedMarkerElement DOM content for the plain circle handles that used to be
// rendered as a `google.maps.SymbolPath.CIRCLE` marker icon (drawing tool, measurement tool).
export const createCircleMarkerContent = ({ fillColor, scale = 1, strokeColor, strokeWidth = 0 }) => {
  const diameter = scale * 2;
  const content = document.createElement('div');
  content.style.background = fillColor;
  content.style.border = `${strokeWidth}px solid ${strokeColor}`;
  content.style.borderRadius = '50%';
  content.style.boxSizing = 'border-box';
  content.style.height = `${diameter}px`;
  content.style.width = `${diameter}px`;
  return content;
};
